<template>
    <div class="tel-select">
        <v-select v-model="phoneType" :options="prefix" inline kind="simple" class="tel-select-sel" />
        <span class="tel-select-split" />
        <v-input v-model="phoneNum" class="tel-select-input" placeholder="请输入" />
    </div>
</template>
<script>
export default {
    props: {
        phone: {
            type: String,
            default: '',
        },
        selType: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            phoneType: this.selType || 1,
            phoneNum: this.phone,
            prefix: [
                {
                    text: '座机',
                    value: 1,
                },
                    {
                    text: '手机号',
                    value: 2,
                },
            ],
        };
    },
    watch: {
        phoneNum(val) {
            this.$emit('change', {
                phone: val,
                phoneType: this.phoneType,
            });
        },
        phoneType(val) {
            this.phoneNum = '';
            this.$emit('change', {
                phone: this.phoneNum,
                phoneType: val,
            });
        },
    },
};
</script>
<style lang="less" scoped>
.tel-select {
    position: relative;
    &-sel {
        position: absolute;
        z-index: 10;
        width: 60px;
        box-sizing: border-box;
        /deep/ .v-select__header-noborder {
            outline-color: transparent;
        }
    }
    &-input {
        width: 100%;
        padding-left: 80px;
    }
    &-split {
        position: absolute;
        z-index: 10;
        width: 1px;
        height: 26px;
        background: #e5e5e5;
        left: 82px;
        top: -2px;
    }
}
</style>
